import classNames from 'classnames'
import React from 'react'
import { Col, ColProps } from 'react-bootstrap'
import styles from './Cards.module.scss'

type CardProps = React.HTMLAttributes<HTMLDivElement> &
  ColProps & {
    cardClassName?: string
  }
export const Card = ({ cardClassName, children, ...rest }: CardProps) => (
  <Col {...rest} className={classNames('p-0', styles.cardCol)}>
    <div className={classNames(styles.card, 'p-2', cardClassName)}>
      {children}
    </div>
  </Col>
)
